import { makeSubmitEditableTableChanges } from "api/makeApiRequestType/makeSubmitEditableTableChanges";
import { OutputRow as ICalFeedsToImportData } from "api/getICalFeedsToImport";

export const saveICalFeedsToImport = makeSubmitEditableTableChanges<
	ICalFeedsToImportData
>("icalFeedsToImport");
